import { api } from './client'

export interface InventoryItem {
    id: string
    product_id: string
    warehouse_id: string
    quantity: number
    min_stock_level: number
    max_stock_level: number
    updated_at: string
    product?: { id: string; name: string; sku: string }
    warehouse?: { id: string; name: string }
}

export interface Warehouse {
    id: string
    name: string
    is_default: boolean
    is_active: boolean
}

// Adjustment reason categories; defect_packing/damaged feed the defects report.
export const ADJUSTMENT_REASON_TYPES = [
    'defect_packing',
    'damaged',
    'expired',
    'correction',
    'other',
] as const
export type AdjustmentReasonType = (typeof ADJUSTMENT_REASON_TYPES)[number]

export const inventoryApi = {
    list: (params?: Record<string, string | number | boolean | undefined>) =>
        api.get<InventoryItem[]>('/inventory', { params }),
    getProductStock: (productId: string) =>
        api.get<InventoryItem[]>(`/inventory/product/${productId}`),
    createAdjustment: (data: {
        product_id: string
        warehouse_id: string
        new_quantity: number
        reason: string
        /** Typed category; defect_packing/damaged feed the defects report. */
        reason_type?: AdjustmentReasonType
        notes?: string
    }) => api.post('/adjustment-notes', data),
    updateThresholds: (data: {
        product_id: string
        warehouse_id: string
        min_stock_level: number
        max_stock_level: number
    }) => api.put('/inventory/thresholds', data),
    getLowStock: (warehouseId: string) =>
        api.get<InventoryItem[]>('/inventory/low-stock', {
            params: { warehouse_id: warehouseId },
        }),
    listWarehouses: () => api.get<Warehouse[]>('/warehouses'),
}
